<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Delay in Carrier Tracking Update
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="carriers"
      :loading="loader"
      :search="search"
      class="elevation-1 custom-icon-size"
      :options.sync="options"
      disable-pagination
      hide-default-footer
    >
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
export default {
  components: {},
  computed: {},
  data: () => ({
    options: {},
    headers: [
      {
        text: "Carrier Name ",
        value: "carrier_name",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },
      {
        text: "Not updated since last 2 hours",
        value: "not_updated_since_last_2_hours",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Retrigger the completed",
        value: "retrigger_the_completed",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    carriers: [],
  }),

  created() {},
  watch: {
    options: {
      handler() {
        this.fetchCarriersTracking();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["getCarriersTracking"]),

    fetchCarriersTracking() {
      this.loader = true;
      this.getCarriersTracking()
        .then((res) => {
          this.loader = false;
          this.carriers = res.data;
        })
        .catch(() => {
          this.loader = false;
        });
    },
  },
};
</script>
